<template><div><h1 id="anlassarten" tabindex="-1"><a class="header-anchor" href="#anlassarten"><span>Anlassarten</span></a></h1>
<p>Anlassarten — Stammtabelle der Anlassarten</p>
<h2 id="beschreibung" tabindex="-1"><a class="header-anchor" href="#beschreibung"><span>Beschreibung</span></a></h2>
<p>Anlassarten dienen der Klassifizierung von Anlassspenden. In dieser Tabelle können verschiedene Anlassarten wie Jubiläen, Hochzeiten, Beerdigungen, etc. erfasst werden.</p>
<p>Pfad: <code v-pre>Personen → Tabellen → Anlassspenden → Anlassarten</code></p>
<h2 id="datenfelder" tabindex="-1"><a class="header-anchor" href="#datenfelder"><span>Datenfelder</span></a></h2>
<dl>
<dt>Anlassart</dt>
<dd>Anlassart</dd>
<dt>Beschreibung</dt>
<dd>Beschreibung der Anlassart</dd>
</dl>
<h2 id="funktionen" tabindex="-1"><a class="header-anchor" href="#funktionen"><span>Funktionen</span></a></h2>
<p>Standardfunktionalität</p>
<h2 id="siehe-auch" tabindex="-1"><a class="header-anchor" href="#siehe-auch"><span>Siehe auch</span></a></h2>
</div></template>


